import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/phone.png'


const _withScopeId = n => (_pushScopeId("data-v-75a547d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top_header" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "body-header",
  style: {"visibility":"hidden"}
}, [
  /*#__PURE__*/_createTextVNode(" Plateforme des "),
  /*#__PURE__*/_createElementVNode("span", { class: "header-text" }, "plaintes et dénonciations"),
  /*#__PURE__*/_createTextVNode(" des actes de corruption et de mauvaise gouvernance ")
], -1))
const _hoisted_4 = { class: "footer_menu" }
const _hoisted_5 = { class: "menu-list menu-visibility" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, "Accueil ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, "Dénoncer", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, "Suivre ma dénonciation", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, "FAQ", -1))
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"contact_mobile\" data-v-75a547d0><div class=\"tenten_mobile\" data-v-75a547d0><img src=\"" + _imports_0 + "\" data-v-75a547d0><span class=\"ten\" data-v-75a547d0> 155</span></div><div class=\"call_free_mobile\" data-v-75a547d0>(Appel gratuit)</div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderPage = _resolveComponent("HeaderPage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HeaderPage),
      _hoisted_3,
      _createElementVNode("footer", _hoisted_4, [
        _createElementVNode("nav", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectmenu('accueil'))),
            id: "nav"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _hoisted_7,
          _createVNode(_component_router_link, { to: "/about" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["menu-item", _ctx.a_about ? 'active' : 'desactive']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectmenu('about')))
              }, " A propos ", 2)
            ]),
            _: 1
          }),
          _hoisted_8,
          _createVNode(_component_router_link, {
            to: "/report",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectmenu('report')))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _hoisted_10,
          _createVNode(_component_router_link, {
            to: "/follow",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectmenu('follow')))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _hoisted_12,
          _createVNode(_component_router_link, {
            to: "/faq",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectmenu('faq')))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _hoisted_14
        ])
      ])
    ])
  ]))
}